<template>
<ClientOnly>
    <a
        target="_blank"
        rel="noopener noreferrer"
        :href="utmWishlistUrl"
        class="wishlist-button external-storefront steam"
        :class="getProductGTMClass(slug)"
        :style="{
            '--wishlist-bg': ctaColor || 'var(--primary-200)',
            '--wishlist-hover-bg': ctaHoverColor || 'var(--primary-100)',
            '--wishlist-color': ctaDark ? 'var(--neutral-50)' : 'var(--neutral-900)',
        }"
        v-on:click="trackWishlistClick"
    >
        <div class="steam-icon-wrapper">
            <PlatformIcon
                platform="steam"
                :icon-color="ctaDark ? 'var(--neutral-50)' : 'var(--neutral-900)'"
                alt="steam"
            />
        </div>
        <span class="x-l-17 wishlist-label">Wishlist on Steam</span>
    </a>
</ClientOnly>
</template>

<script setup lang="ts">
import PlatformIcon from '~/public/images/icons/platforms/PlatformIcon.vue'
import { LaunchDarkly } from '$services/launchdarkly'
import Metric = LaunchDarkly.Metric
import { getProductGTMClass } from '$services/storefronts/storefronts'
import { combineUtmParams } from '$services/tracking'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
    slug: {
        type: String,
        required: true
    },
    wishlistUrl: {
        type: String,
        required: true
    },
    ctaColor: {
        type: String,
        required: true
    },
    ctaHoverColor: {
        type: String,
        required: true
    },
    ctaDark: {
        type: Boolean,
        required: false,
        default: false
    }
})

const app = useNuxtApp()
const route = useRoute()

const utmWishlistUrl = computed(() => {
    if (!props.wishlistUrl) return ''

    const utmUrl = new URL(props.wishlistUrl)

    utmUrl.searchParams.set('utm_source', 'jbg-site')
    utmUrl.searchParams.set('utm_medium', 'desktop-homepage-carousel-slide')
    utmUrl.searchParams.set('utm_campaign', 'announcement-wishlisting')
    utmUrl.searchParams.set('utm_content', 'default')
    combineUtmParams(utmUrl, new URLSearchParams(route.query as Record<string, string>))

    return utmUrl.toString()
})

function trackWishlistClick() {
    if (!props.wishlistUrl) return

    app.$launchDarkly.track(Metric.WishlistClickthroughDesktop, { url: props.wishlistUrl })
}

</script>

<style scoped lang="scss">

.wishlist-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  cursor: pointer;
  border: none;

  width: 100%;
  height: 44px;
  border-radius: 4px;

  background: var(--wishlist-bg);

  &:hover {
    background: var(--wishlist-hover-bg);
    background-blend-mode: plus-lighter, normal;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.08) inset;
  }

  .wishlist-label{
    color: var(--wishlist-color);
  }
}

.steam-icon-wrapper {
  height: 22px;
  width: 22px;
}

</style>
